<template>
  <div class="flex border border-grey-575 rounded-8">
    <DropdownModule
      :width="180"
      append-to-body
      position-menu="right"
      :background="isDarkMode ? 'bg-sidebar' : 'bg-white'"
    >
      <template #button>
        <div class="flex justify-between cursor-pointer text-15 px-10 py-7">
          <div class="flex items-center">
            <i :class="`${currentPage.icon} mr-5`" />
            <p>{{ currentPage.name }}</p>
          </div>
          <i class="icon-keyboard-arrow-down text-12 self-center text-app-color ml-5" />
        </div>
      </template>

      <div class="rounded-10 text-14 text-app-color max-h-264 overflow-y-auto">
        <div
          v-for="page in pages"
          :key="page.name"
          class="first:rounded-t-10 last:rounded-b-10 hover:bg-selection group-scope flex items-center
                 justify-between cursor-pointer border-b last:border-0 p-7 pr-20"
          :class="isDarkMode ? 'border-project' : 'border-grey-500'"
          @click="changePage(page.key)"
        >
          <div>
            <i :class="`${page.icon} mr-5`" />
            {{ page.name }}
          </div>
          <i v-if="page.name.includes(currentPage.key)" class="icon-check_mark text-18 self-center opacity-100 group-hover:opacity-100" />
        </div>
      </div>
    </DropdownModule>
  </div>
</template>

<script>
import DropdownModule from '@/components/shared/form-controls/DropdownModule'

import { defineComponent, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

export default defineComponent({
  components: { DropdownModule },

  emits: ['goToRoute'],

  setup (_, { emit }) {
    const { getters } = useStore()
    const route = useRoute()

    const isDarkMode = computed(() => getters.isDarkMode)
    const isTeamAccount = computed(() => getters.isTeamAccount)

    const pages = computed(() => {
      if (isTeamAccount.value) {
        return [
          { name: 'Pages', key: 'TeamBook', icon: 'icon-projects' },
          { name: 'Tasks', key: 'TaskBoardTeam', icon: 'icon-task_board' },
          { name: 'Discussions', key: 'Discussions', icon: 'icon-discussion' },
          { name: 'Week planner', key: 'WeekPlannerTeam', icon: 'icon-week_planner' },
          { name: 'Chat', key: 'Chat', icon: 'icon-chat1' },
          { name: 'Files', key: 'FileManagerTeam', icon: 'icon-file-manager' }
        ]
      } else {
        return [
          { name: 'Pages', key: 'Book', icon: 'icon-projects' },
          { name: 'Tasks', key: 'TaskBoard', icon: 'icon-task_board' },
          { name: 'Week planner', key: 'WeekPlanner', icon: 'icon-week_planner' },
          { name: 'Files', key: 'FileManager', icon: 'icon-file-manager' }
        ]
      }
    })

    const currentPage = computed(() => {
      return pages.value.find(item => route.name.includes(item.key))
    })

    function changePage (name) {
      emit('goToRoute', name)
    }

    return {
      // computed
      isDarkMode,
      pages,
      currentPage,
      isTeamAccount,
      // functions
      changePage
    }
  }
})
</script>
